import { styled } from '@ori-ui/mui';
import type { ImageSizesHelperParams } from '@ori/image-sizes-helper';
import { getImageVariants, generateSrcSet } from '@ori/image-sizes-helper';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';

const ProductImageRoot = styled('img')(({ theme }) => ({
  objectFit: 'cover',
  borderRadius: theme.shape.largeComponentRadius,
}));

interface ProductImageProps {
  catalogue: string;
  image: string;
  alt: string;
}

export const ProductImage: FC<ProductImageProps> = ({ image, alt, catalogue }) => {
  const { getTestId } = useTestId();

  const imagesVariants: ImageSizesHelperParams = {
    url: image,
    params: [
      {
        width: 131,
        height: 131,
        quality: 90,
      },
      {
        width: 250,
        height: 228,
        quality: 90,
      },
      {
        width: 310,
        height: 282,
        quality: 90,
      },
      {
        width: 375,
        height: 342,
        quality: 80,
      },
      {
        width: 438,
        height: 399,
        quality: 75,
      },
      {
        width: 500,
        height: 456,
        quality: 70,
      },
      {
        width: 688,
        height: 627,
        quality: 65,
      },
      {
        width: 750,
        height: 684,
        quality: 60,
      },
    ],
  };
  const images = getImageVariants(imagesVariants);
  const currentCatalogue = '(max-width: 1023px) 250px, 310px';
  const nextCatalogue = '131px';

  return (
    <ProductImageRoot
      data-testid={getTestId('catalogue-image-root')}
      alt={alt}
      srcSet={generateSrcSet(images)}
      sizes={catalogue === 'current' ? currentCatalogue : nextCatalogue}
      src={images.at(-1)?.url}
    />
  );
};
